import { createContext, useContext } from "react";
const RadioContext = createContext(null);
function useRadioProvider() {
  const context = useContext(RadioContext);
  if (!context) {
    throw new Error(
      "Radio must be used within a RadioGroup. Please wrap your Radio components in a RadioGroup."
    );
  }
  return context;
}
export {
  RadioContext,
  useRadioProvider
};
